import { __decorate, __metadata } from "tslib";
import { BaseMessage, Field } from '@cbbt/lib-interface';
import { IdvSkippedReason } from '../../enums/IdvSkippedReason.js';
export class IdvSkippedRequest extends BaseMessage {
    identityVerificationSkipped;
    identityVerificationSkippedReason;
    individualId;
    owner;
}
__decorate([
    Field.boolean({
        required: true,
        description: 'idv skipped flag',
    }),
    __metadata("design:type", Boolean)
], IdvSkippedRequest.prototype, "identityVerificationSkipped", void 0);
__decorate([
    Field.enum({
        enum: IdvSkippedReason,
        required: true,
        description: 'reason for skipping idv',
    }),
    __metadata("design:type", String)
], IdvSkippedRequest.prototype, "identityVerificationSkippedReason", void 0);
__decorate([
    Field.string({
        required: true,
        description: 'individualId',
        format: 'uuid',
    }),
    __metadata("design:type", String)
], IdvSkippedRequest.prototype, "individualId", void 0);
__decorate([
    Field.string({
        required: false,
        description: 'User ID',
        format: 'uuid',
    }),
    __metadata("design:type", String)
], IdvSkippedRequest.prototype, "owner", void 0);
//# sourceMappingURL=IdvSkippedRequest.js.map